import Vue from "vue";
import VueRouter from "vue-router";

import Router from "../router/router"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "router",
    component: Router,
    beforeEnter: (to, from, next) => {
      if(from.path == '/courseDetails'){
        wx.miniProgram.redirectTo({url:"../../switchPage?into=1&flag=normal"});
      }else{
        next();
      }
    }
  },
  {
    path: "/shop",
    name: "shop",
    component: () => import("../views/courseAndService.vue"),
    meta:{
      keepAlive:true
    }
  },
  {
    path: "/courseDetails",
    name: "courseDetails",
    component: () =>import( "../views/courseDetails.vue"),
  },
  {
    path: "/sharePoster",
    name: "sharePoster",
    component: () => import("../views/sharePoster.vue"),
  },
  {
    path: "/shareShop",
    name: "shareShop",
    component: () => import("../views/shareShop.vue"),
  },
  {
    path: "/video",
    name: "video",
    component:() => import("../views/video.vue"),
  },
  {
    path: "/video2",
    name: "video2",
    component: () => import("../views/video2.vue"),
  },
  {
    path: "/sureOrder",
    name: "sureOrder",
    component: () => import("../views/sureOrder/sureOrder.vue"),
  },
  {
    path: "/payForMe",
    name: "payForMe",
    component: () => import("../views/sureOrder/payForMe.vue"),
  },
  {
    path: "/payForSuccess",
    name: "payForSuccess",
    component: () => import("../views/sureOrder/payForSuccess.vue"),
  },
  {
    path: "/helpPayFor",
    name: "helpPayFor",
    component: () => import("../views/helpPayFor/helpPayFor.vue"),
  },
  {
    path: "/helpPayForDetail",
    name: "helpPayForDetail",
    component: () => import("../views/helpPayFor/helpPayForDetail.vue"),
  },
  {
    path: "/helpPayForFaile",
    name: "helpPayForFaile",
    component: () => import("../views/helpPayFor/helpPayForFaile.vue"),
  },
  {
    path: "/orderDetails",
    name: "orderDetails",
    component: () => import("../views/sureOrder/orderDetails.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
